import { getCulture } from "CMS/utils";
import React from "react";

export type FlagSizes = "large" | "medium" | "small";

const CultureFlag = ({ lcid, style, className = undefined, size = "medium" }: {
  lcid: server.dto.LCID
  style?: React.CSSProperties
  className?: string
  size?: FlagSizes
}) => {
  let height = 0;

  switch (size) {
    case "small":
      height = 12;
      break;
    case "medium":
      height = 16;
      break;
    case "large":
      height = 20;
      break;
  }

  const culture = getCulture(lcid)

  return (
    <img
      src={`https://cdn.systemonesoftware.com/images/flag_${culture.locale.toLowerCase()}.png`}
      alt={culture.text}
      title={culture.text}
      style={{ ...style, height, lineHeight: 0 }}
      className={className} />
  );
};

export default CultureFlag;